import { render, staticRenderFns } from "./EditPlayers.vue?vue&type=template&id=73377e4c&scoped=true"
import script from "./EditPlayers.vue?vue&type=script&lang=ts"
export * from "./EditPlayers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73377e4c",
  null
  
)

export default component.exports